import React from 'react';
import { Modal, Button, List, Empty, message } from 'antd';
import dayjs from '../../../../../../../utils/dayjs';
import './AvailableKeysModal.scss';

async function copyTextToClipboard(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const input = document.createElement('input');
  input.value = text;
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
}

function formatExpiry(val) {
  if (!val || String(val).startsWith('0001-01-01')) return '-';
  const date = dayjs(val);
  return date.isValid() ? date.format('DD/MM/YY') : String(val);
}

function resolveKeyValue(item) {
  if (!item || typeof item !== 'object') return '';
  const raw = item.key ?? item.subscriptionKey ?? item.licenseKey ?? '';
  return raw != null ? String(raw).trim() : '';
}

export default function AvailableKeysModal({ visible, onCancel, availableKeys = [] }) {
  const keys = Array.isArray(availableKeys) ? availableKeys : [];

  const handleCopy = async keyValue => {
    if (!keyValue) {
      message.error('No key to copy.');
      return;
    }

    try {
      await copyTextToClipboard(keyValue);
      message.success('Key copied to clipboard');
    } catch {
      message.error('Unable to copy key');
    }
  };

  const content = keys.length === 0 ? (
    <Empty description="No available keys" className="available-keys-modal__empty" />
  ) : (
    <List
      className="available-keys-modal__list"
      dataSource={keys}
      renderItem={(item, index) => {
        const keyValue = resolveKeyValue(item);

        return (
          <List.Item
            className="available-keys-modal__item"
            actions={[
              <Button
                key="copy"
                size="small"
                icon="copy"
                className="available-keys-modal__copy-btn"
                onClick={() => handleCopy(keyValue)}
                disabled={!keyValue}
              >
                Copy
              </Button>
            ]}
          >
            <List.Item.Meta
              title={
                <span className="available-keys-modal__key" title={keyValue}>
                  {keyValue || `Key ${index + 1}`}
                </span>
              }
              description={
                <span className="available-keys-modal__meta">
                  Expires: {formatExpiry(item.expiryDate)}
                </span>
              }
            />
          </List.Item>
        );
      }}
    />
  );

  return (
    <Modal
      title="Available subscription keys"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      centered
      width={640}
      className="available-keys-modal"
    >
      {content}
    </Modal>
  );
}
